
/// <reference path="../../../../typings/jquery.d.ts"/>
import { AppFormModel } from '../models/AppFormModel';
import { BasicViewService } from "../../../../../shared/services/BasicViewService";
import { GarageTypeApi } from "../../../../../shared/models/generated/FahrzeugdatenGarageTypeApi";
import { AppModelAdapter } from '../models/AppModelAdapter';
import { FahrzeugModel } from '../../../../../shared/models/view/Fahrzeug';
import { AppUtils } from '../../../../../shared/utils/index';

export class AppViewService extends BasicViewService<MyVehicleAppDefinition> {
	private readonly fahrzeugId = '[name="fahrzeugId"]';
	private readonly carTitle = '[name="Autotitel"]';
	private readonly vehicleType = '[name="Fahrzeugart"]';
	private readonly brandAll = '[name="Marke"],[name="MarkeManualChange"]';
	private readonly familyAll = '[name="Baureihe"],[name="BaureiheManualChange"]';
	private readonly modellAll = '[name="Modell"],[name="ModellManualChange"]';
	private readonly brandOthers = '[name="Marke"]';
	private readonly familyOthers = '[name="Baureihe"]';
	private readonly modellOthers = '[name="Modell"]';
	private readonly coachworkOthers = '[name="Karosserievariante"]';
	private readonly brandOnlyCar = '[name="MarkeManualChange"]';
	private readonly familyOnlyCar = '[name="BaureiheManualChange"]';
	private readonly color = '[name="Farbe"]';
	private readonly diplomatCheckbox = '[name="diplomat"]';
	private readonly diplomatNumberplate = '[name="AuslKennzeichen"]';
	private readonly germanNumberplate1 = '[name="plate_1"]';
	private readonly germanNumberplate2 = '[name="plate_2"]';
	private readonly germanNumberplate3 = '[name="plate_3"]';
	private readonly optionSelected = ' option:selected';
	private readonly catalogueImage = '.js-image-autokatalog';
	private readonly catalogueDesktopAndTableImage = '.js-image-desktop-autokatalog';
	private readonly catalogueMobileImage = '.js-image-mobile-autokatalog';
	private readonly modellVariantId = '#modellvariante';
	private readonly vehicleId = '#vehicle';
	private readonly buildingSeriesId = '#buildingseriesgeneration';
	private readonly builingGenerationSelector = '.js-building-series-generation';
	private readonly modelSeriesSelector = '.js-model-series';
	private readonly vehiclesSelector = '.js-vehicles';

	private readonly autocompletePendingFlag = 'autocomlete-pending';

	private updating = false;

	constructor(parent: StepController, options: BasicAppOptions<MyVehicleAppDefinition>, loader: BasicLoader<MyVehicleAppDefinition>) {
		super(parent, options, loader);
		this.formId = this.options.app.applicationId || 'myvehicles';
	}

	public addAutocompleteListeners(
		onBrandAutocomplete: (e: JQuery.Event, term: string, item: JQuery, origEvt: JQuery.Event) => void,
		onSeriesAutocomplete: (e: JQuery.Event, term: string, item: JQuery, origEvt: JQuery.Event) => void): void {
		const $brandOnly = $(this.brandAll);
		const $familyOnly = $(this.familyAll);
		this.addTypeaheadListeners($brandOnly, onBrandAutocomplete);
		this.addTypeaheadListeners($familyOnly, onSeriesAutocomplete);
	}


	private addTypeaheadListeners(typeahead: JQuery,
		selectListener: (event: JQuery.Event, term: string, item: JQuery, origEvt: JQuery.Event) => void): void {
		typeahead.on("automcompleteSelect", (e: JQuery.Event, term: string, item: JQuery, origEvt: JQuery.Event): void => {
			if (origEvt && 'keydown' === origEvt.type && 13 === origEvt.keyCode) { //NOSONAR deprecated false-positiv, s. https://api.jquery.com/category/deprecated/
				typeahead.data(this.autocompletePendingFlag, true);
			}
			selectListener(e, term, item, origEvt);
		});
	}

	public addListeners(viewListener: StandardViewEvents): void {
		const $form = this.getForm();
		$form.find('input, select, ul, li').not('#vehicle_man input, #vehicle_man select, #vehicle_man ul, #vehicle_man li').on("change", viewListener.viewChangeListener.bind(viewListener));
		$form.find('ul, li').on("click", viewListener.viewChangeListener.bind(viewListener));

		$form.on('submit', viewListener.submitListener.bind(viewListener));
		this.$ctx.find('.js-submit-form').on('click', viewListener.submitListener.bind(viewListener));
		S.Utils.FormAside.init();
		S.Lazy.init();
		AppUtils.View.initFormElements();
	}

	public addInputPageListeners(handler: InputPageEvents): void {
		this.$ctx.find('.js-manual-edit').on('click', handler.openDialogListener.bind(handler));
		this.$ctx.find('.js-save-dialog').on('click', handler.saveDialogListener.bind(handler));
		this.$ctx.find(this.vehicleType).on('click', handler.vehicletypeListener.bind(handler));
	}

	public hideCarDetails(): void {
		this.$ctx.find('.js-kfz-additional-informations').toggleClass("h-hidden", true);
	}

	public addFindCarListeners(findCarEvents: FindCarViewEvents): void {
		const $form = this.getForm();

		const $brands = $form.find(this.brandAll);
		$brands.on('focusin', findCarEvents.onFocusInBrandListener.bind(findCarEvents));
		$brands.on('change', findCarEvents.onChangeBrandListener.bind(findCarEvents));

		const $family = $form.find(this.familyAll);
		$family.on('focusin', findCarEvents.onFocusInFamilyListener.bind(findCarEvents));
		$family.on('change', findCarEvents.onChangeFamilyListener.bind(findCarEvents));

		$form.find(this.builingGenerationSelector).on('change', findCarEvents.onBaureiheGenerationenChangeListener.bind(findCarEvents));
		$form.find(this.modelSeriesSelector).on('change', findCarEvents.onModellVarianteChangeListener.bind(findCarEvents));
		$form.find(this.vehiclesSelector).on('change', findCarEvents.viewChangeListener.bind(findCarEvents));
	}

	public addOptionListeners(editVehicleListener: (e: JQuery.Event) => void, deleteVehicleListener: (e: JQuery.Event) => void, addVehicleListener: (e: JQuery.Event) => void): void {
		if (editVehicleListener) {
			this.$ctx.find('.js-edit-vehicle').on('click', editVehicleListener);
		}
		if (deleteVehicleListener) {
			this.$ctx.find('.js-delete-vehicle').on('click', deleteVehicleListener);
		}
		if (addEventListener) {
			this.$ctx.find('.js-add-vehicle').on('click', addVehicleListener);
		}
		S.Lazy.init();
	}

	public updateAutokatalogUrls(vehicleID: string): void {
		const $links = this.$ctx.find(".js-link-autokatalog");
		const updatedUrl = AppUtils.Url.updateUrlParameter(
			{
				myVehicleId: vehicleID
			},
			$links.eq(0).attr('href')
		);
		$links.attr('href', updatedUrl);
	}

	public updateAutokatalogImage(formModel: AppFormModel): void {
		if (formModel.Fahrzeug.BildDateiName) {
			this.$ctx.find(this.catalogueDesktopAndTableImage).attr("srcset", this.options.app.cataloguedesktopimagesurl + formModel.Fahrzeug.BildDateiName);
			this.$ctx.find(this.catalogueMobileImage).attr("srcset", this.options.app.cataloguemobileimagesurl + formModel.Fahrzeug.BildDateiName);
			this.$ctx.find(this.catalogueImage).attr("src", this.options.app.cataloguedesktopimagesurl + formModel.Fahrzeug.BildDateiName);
			this.$ctx.find(this.catalogueImage).toggleClass("h-hidden", false);
		}
	}

	public getFormModelFromView(formModel: AppFormModel): AppFormModel {
		const result = formModel || new AppFormModel();

		if (!result.Fahrzeug) {
			result.Fahrzeug = new FahrzeugModel();
		}
		result.Fahrzeug.Fahrzeugart = this.getFieldNumberVal(`${this.vehicleType}:checked`);
		result.Fahrzeug.ID = this.getFieldStringVal(this.fahrzeugId);
		result.Fahrzeug.FahrzeugTitel = this.getFieldStringVal(this.carTitle);
		result.Fahrzeug = this.getNumberplateFromView(result.Fahrzeug);

		if (result.Fahrzeug.Fahrzeugart !== GarageTypeApi.Anhaenger) {
			if (result.Fahrzeug.Fahrzeugart === GarageTypeApi.Pkw) {
				result.Fahrzeug = this.getPkwDataFromView(result.Fahrzeug);
			} else {
				result.Fahrzeug.Marke = this.getFieldStringVal(this.brandOthers);
				result.Fahrzeug.Modell = this.getFieldStringVal(this.modellOthers);
				result.Fahrzeug.Baureihe = this.getFieldStringVal(this.familyOthers);
				result.Fahrzeug.Karosserievariante = this.getFieldStringVal(this.coachworkOthers);
			}

			result.Fahrzeug.Farbe = this.getFieldNumberVal(this.color + this.optionSelected);
		}

		return result;
	}


	private getPkwDataFromView(model: FahrzeugModel): FahrzeugModel {
		const result = model || new FahrzeugModel();
		const $ctx = $('#vehicle_man');
		if (!$ctx.is(":visible")) {
			return result;
		}
		result.Marke = this.getFieldStringVal(this.brandOnlyCar, $ctx);
		result.Baureihe = this.getFieldStringVal(this.familyOnlyCar, $ctx);

		const $buildingSeriesGenerationSelection = $(this.builingGenerationSelector).find(":selected");
		result.BaureiheGeneration = this.getFieldStringVal($buildingSeriesGenerationSelection);
		if ("0" === result.BaureiheGeneration) {
			result.BaureiheGeneration = undefined;
		}
		if (result.BaureiheGeneration) {
			result.BaureiheGenerationId = $buildingSeriesGenerationSelection.data('keyid');
			result.TetId = $buildingSeriesGenerationSelection.data('tetid');
		}

		const $modelSeriesSelection = $(this.modelSeriesSelector).find(":selected");
		result.Modell = this.getFieldStringVal($modelSeriesSelection);
		if ("0" === result.Modell) {
			result.Modell = undefined;
		}
		if (result.Modell) {
			result.ModellId = $modelSeriesSelection.data('keyid');
			result.TetId = $modelSeriesSelection.data('tetid');
		}

		const $vehiclesSelection = $(this.vehiclesSelector).find(":selected");
		result.FahrzeugBezeichnung = this.getFieldStringVal($vehiclesSelection);
		if ("0" === result.FahrzeugBezeichnung) {
			result.FahrzeugBezeichnung = undefined;
		}
		if (result.FahrzeugBezeichnung) {
			result.TetId = $vehiclesSelection.data('tetid');
			result.KfzId = $vehiclesSelection.data('keyid');
		}

		return result;
	}

	public setVehicleType(formModel: AppFormModel): void {
		if (formModel.Fahrzeug.Fahrzeugart !== GarageTypeApi.Pkw) {
			this.setSelectFromCatalogHintVisibility(true);
			this.setPkwListVisibility(true);
		} else if (!formModel.Fahrzeug.Marke) {
			this.setSelectFromCatalogHintVisibility(false);
			this.setPkwListVisibility(true);
		} else {
			this.setSelectFromCatalogHintVisibility(true);
			this.setPkwListVisibility(false);
		}
	}

	public updatePkwViewparts(formModel: AppFormModel): void {
		this.setVehicleType(formModel);

		this.$ctx.find(".js-pkw-karosse").text(formModel.Fahrzeug.Karosserievariante);

		this.$ctx.find(".js-pkw-marke").text(formModel.Fahrzeug.Marke);
		this.$ctx.find(".js-pkw-baureihe").text(formModel.Fahrzeug.Baureihe);

		this.$ctx.find(".js-pkw-baureihengeneration").text(formModel.Fahrzeug.BaureiheGeneration || '');
		this.$ctx.find(".js-pkw-modell").text(formModel.Fahrzeug.Modell || '');
		this.$ctx.find(".js-pkw-fahrzeugbezeichnung").text(formModel.Fahrzeug.FahrzeugBezeichnung || '');
	}

	private setSelectFromCatalogHintVisibility(hide: boolean): void {
		this.$ctx.find(".js-hint-select-from-catalog").toggleClass("h-hidden", hide);
	}

	private setPkwListVisibility(hide: boolean): void {
		this.$ctx.find(".js-pkw-list").toggleClass("h-hidden", hide);
	}

	public getSelectedVehicletype(): number {
		return Number(this.$ctx.find(`${this.vehicleType}:checked`).val());
	}

	public setFormModelToView(formModel: AppFormModel): void {
		if (this.updating) {
			return;
		}
		this.updating = true;
		// hide trailer option in case the type list is not yet published in CMS
		AppUtils.View.hideElement(this.$ctx.find(`${this.vehicleType}[value="${GarageTypeApi.Anhaenger}"]`).parent(), true);

		if (formModel.Fahrzeug.BaureiheGeneration) {
			$(this.builingGenerationSelector).val(`${formModel.Fahrzeug.BaureiheGeneration}`);
		} else {
			$(this.modelSeriesSelector).prop("disabled", true);
		}
		if (formModel.Fahrzeug.Modell) {
			$(this.modelSeriesSelector).val(`${formModel.Fahrzeug.Modell}`);
		} else {
			$(this.vehiclesSelector).prop("disabled", true);
		}

		if (formModel.Fahrzeug.FahrzeugBezeichnung) {
			$(this.vehiclesSelector).val(`${formModel.Fahrzeug.FahrzeugBezeichnung}`);
		}

		if (formModel.Fahrzeug.Farbe >= 0) {
			this.$ctx.find(this.color).val(formModel.Fahrzeug.Farbe).trigger("change");
			this.$ctx.find(`.aa-color-options-list [data-value="${formModel.Fahrzeug.Farbe}"]`).trigger("click");
			this.$ctx.find('.aa-color-options').removeClass('is-opened');
			this.$ctx.find('.aa-btn-color-selection').removeClass('is-opened');
		}
		if (formModel.Fahrzeug.AuslOderDiplomat) {
			this.$ctx.find(this.diplomatNumberplate).val(formModel.Fahrzeug.KennzeichenPrefix);
			this.$ctx.find(this.germanNumberplate1).val('');
			this.$ctx.find(this.germanNumberplate2).val('');
			this.$ctx.find(this.germanNumberplate3).val('');

			this.$ctx.find(this.diplomatCheckbox).prop('checked', true).trigger('change');
		} else {
			this.$ctx.find(this.diplomatNumberplate).val('');
			this.$ctx.find(this.germanNumberplate1).val(formModel.Fahrzeug.KennzeichenPrefix);
			if (formModel.Fahrzeug.KennzeichenSuffix) {
				this.$ctx.find(this.germanNumberplate2).val(formModel.Fahrzeug.KennzeichenSuffix.match(/^[A-Za-z]*/));
				this.$ctx.find(this.germanNumberplate3).val(formModel.Fahrzeug.KennzeichenSuffix.match(/[^a-zA-Z\s]*[0-9]+[EH]?/));
			} else {
				this.$ctx.find(this.germanNumberplate2).val('');
				this.$ctx.find(this.germanNumberplate3).val('');
			}

			this.$ctx.find(this.diplomatCheckbox).prop('checked', false).trigger('change');
		}
		this.updating = false;
	}

	public resetFamilyData(formModel: AppFormModel): void {
		const $carFamilyInput = $(this.familyAll);
		$carFamilyInput.val('');
		formModel.Fahrzeug.Baureihe = null;
		formModel.Fahrzeug.BaureiheId = '';

		this.resetModellData(formModel);
	}

	public enableFamilyData(enable: boolean): void {
		const $carBrandinput = $(this.brandOnlyCar);
		const $carFamilyInput = $(this.familyOnlyCar);

		if (enable && !AppUtils.Helper.isEmptyString($carBrandinput.val())) {
			$carFamilyInput.val('');
			$carFamilyInput.prop("disabled", false);
		} else {
			$carFamilyInput.prop("disabled", true);
		}
	}

	public checkEnableBaureihenGenerationSelection(): boolean {
		const $baureihengenerationSelection = $(this.builingGenerationSelector);
		const $familyCarInput = $(this.familyOnlyCar);
		if (!AppUtils.Helper.isEmptyString($familyCarInput.val())) {
			$baureihengenerationSelection.prop("disabled", false);
			return true;
		} else {
			$baureihengenerationSelection.prop("disabled", true);
			return false;
		}
	}

	public updateBrandsSearchURL(formModel: AppFormModel): void {
		const $carBrandinput = $(this.brandAll);
		$carBrandinput.each((index, element) => {
			const $elm = $(element);
			const apilUrl = AppUtils.Url.updateUrlParameter({
				Status: AppModelAdapter.getDefaultMarkenStatus(),
				Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
			}, $elm.data('searchurl'));
			$elm.data('searchurl', apilUrl);
		});
	}

	public updateFamilySearchURL(formModel: AppFormModel): void {
		const $carFamilyInput = $(this.familyAll);
		$carFamilyInput.each((index, element) => {
			const $elm = $(element);
			const apilUrl = AppUtils.Url.updateUrlParameter({
				Brand: formModel.Fahrzeug.Marke,
				BrandId: formModel.Fahrzeug.MarkeId,
				Status: AppModelAdapter.getDefaultMarkenStatus(),
				Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
			}, $elm.data('searchurl'));

			$elm.data('searchurl', apilUrl);
		});
	}

	public updateModelSearchURL(formModel: AppFormModel): void {
		$(this.modellOthers).each((index, element) => {
			const $elm = $(element);
			const apilUrl = AppUtils.Url.updateUrlParameter({
				Brand: formModel.Fahrzeug.Marke,
				Series: formModel.Fahrzeug.Baureihe,
				SeriesId: formModel.Fahrzeug.BaureiheId,
				Status: AppModelAdapter.getDefaultMarkenStatus(),
				Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
			}, $elm.data('searchurl'));

			$elm.data('searchurl', apilUrl);
		});
	}

	public resetModellData(formModel: AppFormModel): void {
		const $carModellInput = $(this.modellAll);
		$carModellInput.val('');
		formModel.Fahrzeug.Modell = null;
	}

	public getModelSearchUrlFromView(): string {
		return this.$ctx.find(this.modellAll).data('searchurl');
	}

	public showApiErrorMessage(show = true): void {
		const elm = this.$ctx.find(".js-apierror");
		elm.toggleClass("h-hidden", !show);
		if (show && elm.length) {
			elm[0].scrollIntoView();
		}
	}


	public removeAllOptionExceptFirstAndDisableField(className: string, disabled: boolean): void {
		const $field = $(className);
		if (!disabled) {
			$field.find('option').not(':first').remove();
		}
		$field.prop("disabled", disabled);

		let $fieldValidation = $field[0].closest('div.is-valid.is-check');
		if ($fieldValidation) {
			$($fieldValidation).closest('div.is-valid.is-check').removeClass("is-valid is-check");
		}

		$fieldValidation = $field[0].closest('div.is-error.is-check');
		if ($fieldValidation) {
			$($fieldValidation).closest('div.is-error.is-check').removeClass("is-error is-check");
			$($field[0]).removeClass('is-error');
		}
	}

	private getNumberplateFromView(model: FahrzeugModel): FahrzeugModel {
		const result = model || new FahrzeugModel();
		result.AuslOderDiplomat = this.$ctx.find(this.diplomatCheckbox).is(':checked');
		if (result.AuslOderDiplomat) {
			result.KennzeichenPrefix = this.getFieldStringVal(this.diplomatNumberplate);
			result.KennzeichenSuffix = '';
		} else {
			result.KennzeichenPrefix = this.getFieldStringVal(this.germanNumberplate1);
			if (result.KennzeichenPrefix) {
				result.KennzeichenSuffix = [this.getFieldStringVal(this.germanNumberplate2), this.getFieldStringVal(this.germanNumberplate3)].join(" ");
			}
		}

		return result;
	}

	public clearBaureiheGenerationenSelect(): void {
		this.removeAllOptionExceptFirstAndDisableField(this.buildingSeriesId, false);
	}

	public fillBaureihenGenerationSelections(baureihenGenerationen: BaureiheGenerationWithKeyApi[], selectKey: string): void {
		if (baureihenGenerationen && baureihenGenerationen.length) {
			baureihenGenerationen.forEach(element => {
				const $elm = this.createOption($(this.buildingSeriesId), element.Name, element.Name, element.Id, element.Key);
				if (selectKey && element.Id === selectKey) {
					$elm.prop('selected', true);
				}
			});
		}
	}

	public fillModellVariantenSelections(modellVarianten: ModellVarianteWithKeyApi[]): void {
		const hasModels = modellVarianten && modellVarianten.length;
		this.removeAllOptionExceptFirstAndDisableField(this.modellVariantId, !hasModels);
		if (hasModels) {
			modellVarianten.forEach(element =>
				this.createOption($(this.modellVariantId), element.Name, element.Name, element.Id, element.Key)
			);
		}
	}

	public fillVehicleSelections(vehicles: FahrzeugWithKeyApi[]): void {
		const hasVehicles = vehicles && vehicles.length;
		this.removeAllOptionExceptFirstAndDisableField(this.vehicleId, !hasVehicles);
		if (hasVehicles) {
			vehicles.forEach(element =>
				this.createOption($(this.vehicleId), element.Name, element.Name, element.Id, element.Key)
			);
		}
	}

	private createOption(selection: JQuery, value: string, text: string, id: string, tetid: string): JQuery {
		const $option = ($("<option></option>")
			.attr("value", value)
			.text(T.Utils.Helper.htmlToText(text)));
		T.Utils.View.setDataSafe($($option), 'keyid', id);
		T.Utils.View.setDataSafe($($option), 'tetid', tetid);

		selection.append($option);
		return $option;
	}

	public setValueAndEnableLayerField(name: string, selectKey: string): void {
		const $field = $(`[name="${name}"]`);
		$field.find(`[data-keyid="${selectKey}"]`).prop('selected', true);
		$field.prop('disabled', false);
	}

	public getFieldStringVal(fieldSel: string | JQuery, ctx?: JQuery): string {
		const result = 'function' === typeof (fieldSel as any)['val'] ? (fieldSel as JQuery).val() : (ctx || this.$ctx).find(fieldSel as JQuery.Selector).val();
		return null == result ? undefined : result.toString(); //NOSONAR
	}

	public getFieldNumberVal(fieldSel: string | JQuery, ctx?: JQuery): number {
		let result = ('function' === typeof (fieldSel as any)['val'] ? (fieldSel as JQuery).val() : (ctx || this.$ctx).find(fieldSel as JQuery.Selector).val());
		if (result) {
			result = result.toString().replace(/\./g, '').replace(',', '.');
		}
		return isNaN(result as any) || null == result ? undefined : Number(result); //NOSONAR
	}
}
